export default __webpack_public_path__ + "static/media/page-not-found.0ca8f58f.png";